function checkStringNumber(number, limit) {
  var allowed_charecters = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  var replace_number = {
    '۰': '0',
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
  };

  for (var i = 0; i < number.length; i++) {
    if (replace_number.hasOwnProperty(number[i])) {
      number = number.replace(number[i], replace_number[number[i]]);
    }
  }
  //number.replace(/۱/g, '1')
  var last = number.slice(-1);
  if (!(last in allowed_charecters)) {
    number = number.slice(0, -1);
  }
  if (limit != null) {
    if (number.length > limit) {
      number = number.slice(0, -1);
    }
  }
  return number;
}

const scrollToTop = () => {
  window.scrollTo(0, 0);
  return true;
};

const replaceEnNumberToFa = (inputString) => {
  var replacNumber = {
    0: '۰',
    1: '۱',
    2: '۲',
    3: '۳',
    4: '۴',
    5: '۵',
    6: '۶',
    7: '۷',
    8: '۸',
    9: '۹',
  };
  for (let i = 0; i < inputString.length; i++) {
    if (replacNumber.hasOwnProperty(inputString[i])) {
      inputString = inputString.replace(inputString[i], replacNumber[inputString[i]]);
    }
  }
  return inputString;
};

const startTitleAnimation = () => {
  let titleText = 'اسپارو';
  titleText += ' 🦅 ';
  titleText += 'پلتفرم امن و جامع آگهی در ایران';
  titleText += ' 🦅 ';

  let position = 0;

  setInterval(() => {
    document.title = titleText.substring(position) + titleText.substring(0, position);

    position = (position + 1) % titleText.length;
  }, 400);
};

module.exports = {
  startTitleAnimation,
  checkStringNumber,
  replaceEnNumberToFa,
  scrollToTop,
};
